import { CardTable } from 'shared/mui/Card/CardTableNew/CardTable';
import { TableRowWrapper } from 'shared/mui/Table/TableRowWrapperNew/TableRowWrapper';
import { ImageField, TextField } from 'shared/react-admin/Fields';

type Props = {
  sourceId?: string;
};

export const MethodLogosShowDialogTable: React.FC<Props> = ({ sourceId = 'originId' }) => {
  return (
    <CardTable tableBodyProps={{ sx: { '& td': { width: '100px' } } }}>
      <TableRowWrapper label="ID">
        <TextField source={sourceId} />
      </TableRowWrapper>
      <TableRowWrapper label="Название">
        <TextField
          source="name"
          sx={{
            display: 'inline-block',
            overflowWrap: 'break-word',
            maxWidth: '290px',
          }}
        />
      </TableRowWrapper>
      <TableRowWrapper label="Лого">
        <ImageField
          label="Логотип"
          source="filePath"
          sx={{
            '& .RaImageField-image': {
              maxWidth: 64,
              minWidth: 64,
              minHeight: 'auto',
              margin: 0,
              objectFit: 'contain',
            },
          }}
        />
      </TableRowWrapper>
    </CardTable>
  );
};
